import { render, staticRenderFns } from "./authFooter.vue?vue&type=template&id=6ffbc06a&scoped=true"
import script from "./authFooter.vue?vue&type=script&lang=js"
export * from "./authFooter.vue?vue&type=script&lang=js"
import style0 from "./authFooter.vue?vue&type=style&index=0&id=6ffbc06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbc06a",
  null
  
)

export default component.exports